module.exports = __webpack_public_path__ + "static/media/CircularStd-Bold.145ae1e7.ttf";